var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classString,attrs:{"href":"#","title":_vm.text.copy + ' ' + _vm.linkName},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.text.copy))])}
var staticRenderFns = []

export { render, staticRenderFns }